<div class="mobile-input-container" [ngClass]="{'error': !!error}">
    <!-- Suffix icon -->
    <div *ngIf="!!iconClass && !disabled" class="input-suffix input-icon {{iconClass}}" (click)="toggleIcon()">
    </div>
    <input 
        [attr.name]="formControlName" 
        [attr.type]="type" 
        [value]="value" 
        [(ngModel)]="value" 
        class="input" 
        (change)="handleChange($event)" 
        (focus)="onInputFocus()"
        (focusout)="onInputFocusOut()" 
        [attr.disabled]="disabled || processing ? '' : null" 
        [attr.readonly]="readonly ? '' : null"
        [attr.invalid]="error ? '' : null" 
        [attr.maxlength]="maxLength" 
        min="1" 
        [attr.max]="max" 
        [attr.autocomplete]="autocomplete"
        [attr.autocapitalize]="autocapitalize" 
        #input 
        [ngClass]="{'has-value': !!value, 'error': error, 'mobile': mobile}">
    <label 
        [for]="formControlName" 
        [ngClass]="{'error': error}" 
        (click)="focusInput()">{{placeholder}}</label>
</div>
<div class="mobile-input-error-message">
    <ng-content select="[error]"></ng-content>
</div>